import React from "react";
import {Switch, Route, Redirect} from "react-router-dom";
import * as routes from "../../routes/routeConstants/appRoutes";
import Exams from "./Exams";
import ExamSubjects from "./Subjects"
import ExamChapters from "./Chapters"
import PreviousPaper  from "./PreviousPaper";
const ExamRouter = () => {
    return(
        <Switch>
            <Route exact path={routes.EXAMS} component={Exams}/>
            <Route exact path={routes.EXAM_SUBJECTS} component={ExamSubjects} />
            <Route exact path={routes.EXAM_SUBJECT_CHAPTERS} component={ExamChapters} />
            <Route exact path={routes.PREVIOUS_PAPER} component={PreviousPaper} />
        </Switch>
    )
}
export default ExamRouter